import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from '@supoui/core/services/http.service';
import { PurposeOfTravelItemType, PurposeOfTravelItemTypeAdapter } from '@supoui/shared/model/purpose-of-travel-item-type';
import {
  CauseItemType,
  CauseLevel1ItemTypeAdapter,
  CauseLevel2ItemTypeAdapter,
  CauseLevel3ItemTypeAdapter
} from '@supoui/shared/model/cause-item-type';
import { ServiceItemType, ServiceItemTypeAdapter } from '@supoui/shared/model/service-item-type';
import { SupoType, SupoTypeAdapter } from '@supoui/shared/model/supo-type';

@Injectable({
  providedIn: 'root'
})
export class MasterListService {
  constructor(
    private httpService: HttpService,
    private serviceItemTypeAdapter: ServiceItemTypeAdapter,
    private purposeOfTravelItemTypeAdapter: PurposeOfTravelItemTypeAdapter,
    private causeLevel1ItemTypeAdapter: CauseLevel1ItemTypeAdapter,
    private causeLevel2ItemTypeAdapter: CauseLevel2ItemTypeAdapter,
    private causeLevel3ItemTypeAdapter: CauseLevel3ItemTypeAdapter,
    private supoTypeAdapter: SupoTypeAdapter
  ) {}

  public getServiceItemList(): Observable<ServiceItemType[]> {
    return this.httpService
      .get<ServiceItemType[]>('services/onepoint/api/masterlist/service-item-list')
      .pipe(map((data: any[]) => data.map(item => this.serviceItemTypeAdapter.adapt(item))));
  }

  public getPurposeOfTravelList(): Observable<PurposeOfTravelItemType[]> {
    return this.httpService
      .get<PurposeOfTravelItemType[]>('services/onepoint/api/masterlist/purpose-of-travel-list')
      .pipe(map((data: any[]) => data.map(item => this.purposeOfTravelItemTypeAdapter.adapt(item))));
  }

  public getAllLevel1Causes(): Observable<CauseItemType[]> {
    return this.httpService
      .get<CauseItemType[]>('services/onepoint/api/masterlist/causes/level1/all')
      .pipe(map((data: any[]) => data.map(item => this.causeLevel1ItemTypeAdapter.adapt(item))));
  }

  public getAllLevel2Causes(): Observable<CauseItemType[]> {
    return this.httpService
      .get<CauseItemType[]>('services/onepoint/api/masterlist/causes/level2/all')
      .pipe(map((data: any[]) => data.map(item => this.causeLevel2ItemTypeAdapter.adapt(item))));
  }

  public getAllLevel3Causes(): Observable<CauseItemType[]> {
    return this.httpService
      .get<CauseItemType[]>('services/onepoint/api/masterlist/causes/level3/all')
      .pipe(map((data: any[]) => data.map(item => this.causeLevel3ItemTypeAdapter.adapt(item))));
  }

  public getSupoTypes(): Observable<SupoType[]> {
    return this.httpService
      .get<SupoType[]>(`services/onepoint/api/masterlist/supotypes`)
      .pipe(map(items => items.map(item => this.supoTypeAdapter.adapt(item))));
  }
}
